import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import blogList from '../../components/BlogData';
import TopBanner from '../../components/TopBanner';
import BlogSideBar from '../../components/BlogSideBar';
import { NoContentForNow } from '../../components/NoContentForNow';
 
export default function CategoryBlogs(props) {
    const categoryName = props.categoryname || "Liferay";
    const allBlogs = [...blogList].sort((a, b) => new Date(b.displaydate) - new Date(a.displaydate));
    const filteredBlogs = allBlogs.filter(blog => blog.category === props.categoryname);

    const server_url = process.env.REACT_APP_SERVER;
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Lurantech Blogs Categories",
        "url": server_url +"/category/" + categoryName,
        "description": "Explore various blog categories from Lurantech. Learn about IT solutions, software development, business strategies, cloud computing, and more. Find blog posts organized by category for easier access.",
        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": server_url + "/category/" + categoryName
        },
        "publisher": {
            "@type": "Organization",
            "name": "Lurantech",
            "logo": {
                "@type": "ImageObject",
                "url": server_url + "/images/logo.png"
            }
        },
        "mainEntity": {
            "@type": "ItemList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": categoryName,
                    "url": server_url + "/category/" + categoryName,
                    "description": "Explore our latest blog posts in the " + categoryName + " category. Stay updated with IT solutions, software development, business strategies, and more."
                }
            ]
        }
    };

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <meta property="og:title" content={`Lurantech | Category | ${categoryName}`} />
                    <meta property="og:description" content={`Explore our latest blog posts in the ${categoryName} category. Stay updated with IT solutions, software development, business strategies, and more.`} />
                    <meta property="og:url" content={`${server_url}/category/${categoryName}`} />
                    <meta property="og:image" content={`${server_url}/images/home/home.jpg`} />
                    <meta property="og:type" content="website" />
                    <meta property="og:image:type" content="image/jpeg" />
                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="675" />

                    <meta name="twitter:title" content={`Lurantech | Category | ${categoryName}`} />
                    <meta name="twitter:description" content={`Discover insightful content in the ${categoryName} category. Get expert insights on IT solutions, software development, and more.`} />
                    <meta name="twitter:image" content={`${server_url}/images/home/home.jpg`} />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta property="twitter:image:type" content="image/jpeg" />
                    <meta property="twitter:image:width" content="1200" />
                    <meta property="twitter:image:height" content="675" />
                    <meta name="geo.position" content="22.3026;73.1812" />
                    <meta name="geo.placename" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />
                    <meta name="geo.region" content="IN-GJ" />
                    <meta property="og:latitude" content="22.3026" />
                    <meta property="og:longitude" content="73.1812" />
                    <meta property="og:location" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />


                    <meta name="robots" content="index, follow" />
                    <meta name="description" content={`Browse our ${categoryName} blog category to find the latest updates on IT solutions, software development, and business strategies.`} />
                    <meta name="keywords" content={`${categoryName}, IT solutions, software development, business strategies, technology trends, liferay, shopify, springboot, aws`} />
                    <meta name="author" content="Lurantech" />

                    <link rel="canonical" href={`${server_url}/category/${categoryName}`} />
                    <link rel="preload" href={`${server_url}/images/home/home.jpg`} as="image" />
                    <title>Lurantech | Category | {categoryName}</title>
                </Helmet>

                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(schemaData),
                    }}
                />

                {filteredBlogs.length === 0 ? (
                    <NoContentForNow />
                ) : (
                    <>
                        <TopBanner title={props.categoryname} />
                        <div className="blog-container container">
                            <div className="row g-0">
                                <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                                    {filteredBlogs.map((blog, index) => (
                                        <div key={`category-blogs-${index}`} className="s-blog-container">
                                            <div className="blog-img">
                                                <img src={blog.imageUrlPath} alt={blog.title || 'Blog Image'} />
                                            </div>
                                            <div className="blog-info">
                                                <img src="/images/blogs/author-icon.svg" alt="Lurantech author" />
                                                <div className='author-text'>{blog.author}</div>
                                                <img src="/images/blogs/clock-icon.svg" alt="Lurantech blog display date" />
                                                <div className='clock-text'>{blog.displaydate.toDateString()}</div>
                                            </div>
                                            <div className="blog-title">
                                                <Link to={`/blog/${blog.title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()}`} >{blog.title}</Link>
                                            </div>
                                            <div className="blog-description">
                                                {blog.description}
                                            </div>
                                            <div className="blog-button">
                                                <Link to={`/blog/${blog.title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()}`} >Read More &#x2197;</Link>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                    <BlogSideBar blog={filteredBlogs[0]} />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </HelmetProvider>
        </>
    );
}
